export class RiskFactorInfo {
  // public 変数 ------------------------------------------------------------------------
  public agentCode:					string = null;    // 代理店コード
  public companyProductCode:		string = null;    // 保険商品
  public destinationGroupCode:		string = null;    // 方面コード
  public destinationGovCode:		string = null;    // 渡航先コード
  public destinationCountryCode:	string = null;    // 国コード
  public startDate: 				string = null;    // 出発日
  public endDate:					string = null;    // 帰国日
  public numberOfInsured:			number = 0;    // 人数
  public purposeCode:				string = null;    // 旅行の目的コード
  // WRQ-3496_ 【旅行保険】代理店追加対応 阪急交通社(ホワイトラベル）----------START
  public memberNo:				string = null;    // 会員番号
  // WRQ-3496_ 【旅行保険】代理店追加対応 阪急交通社(ホワイトラベル）----------END
  // -------------------------------------------------------------------------------------
}
